import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/accordion.module.scss'

type Props = {
  children: ReactNode
}

const AccordionItem: FC<Props> = (props) => {
  const { children } = props
  return <div className={styles.accordion__item}>{children}</div>
}

export default AccordionItem
